angular.module('mercury.modules.time.payroll', [
  'mercury.modules.time.payroll.adjustment',
  'mercury.modules.time.payroll.payrun',
  'mercury.modules.time.payroll.paytypes'
]);
